import { SoundService as BaseSoundService, SoundType } from '@pascal/pascal-core';
import { defaultSounds } from '@pascal/pascal-core/shared/core/services/sound/defaultSounds';

defaultSounds.music.loop = true;

const SoundTypes = {
  chip: 'chip',
  cardOpen: 'cardOpen',
  cardHold: 'cardHold',
  amount: 'amount',
  cashout: 'cashout',
  double: 'double',
  contest3: `contest3-${SoundType.Music}`,
};

const options = [
  {
    src: 'placingChip.mp3',
    name: SoundTypes.chip,
    autoplay: false,
    html5: true,
  },
  {
    src: 'card.mp3',
    name: SoundTypes.cardOpen,
    autoplay: false,
    html5: true,
  },
  {
    src: 'card_hold.mp3',
    name: SoundTypes.cardHold,
    autoplay: false,
    html5: true,
  },
  {
    src: 'amount.mp3',
    name: SoundTypes.amount,
    autoplay: false,
    html5: true,
  },
  {
    src: 'cashout.mp3',
    name: SoundTypes.cashout,
    autoplay: false,
    html5: true,
  },
  {
    src: 'double.mp3',
    name: SoundTypes.double,
    autoplay: false,
    html5: true,
  },
  {
    src: 'contest3.mp3',
    name: SoundTypes.contest3,
    autoplay: false,
    html5: true,
    loop: true,
  },
];

class SoundService extends BaseSoundService {
  constructor(props) {
    super(props);
  }
}

const soundService = new SoundService({
  options,
});

export { soundService, SoundTypes as soundTypes };
